// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__MQwcZ","link":"UploadComponent_link__N7LaO"};